import React from 'react';

export const CURRENCY_CODES: { [key: string]: string } = {
	USD: '$',
	CZK: 'Kč',
	EUR: '€',
	MXN: '$',
	PEN: 'S/',
	COP: '$',
	HUF: 'Ft',
	PLN: 'zł',
	RSD: 'RSD',
};

interface Props {
	currency: string;
}

export const getCurrencyCode = (currency: string) => {
	return CURRENCY_CODES[currency] ?? currency;
};

const PriceCurrency: React.FC<Props> = ({ currency }) => {
	return (
		// @ts-ignore
		<>{getCurrencyCode(currency)}</>
	);
};

export default PriceCurrency;
